import React, { useMemo } from 'react'
import './index.less'

interface GoodsImgProps {
  src?: string
  /**是否失效 */
  ifExpired?: boolean
  /**是否售罄 */
  ifSoldOut?: boolean
  onClick?: Function
}

export default function GoodsImg({
  src,
  onClick,
  ifExpired,
  ifSoldOut,
}: GoodsImgProps) {
  const tipsText = useMemo(() => {
    if (ifExpired) return '下架'
    if (ifSoldOut) return '缺货'
    return ''
  }, [ifExpired, ifSoldOut])

  return (
    <div className="card-product-img" onClick={() => onClick?.()}>
      {tipsText && <div className="card-product-img-tips">{tipsText}</div>}
      <img src={src} alt="" />
    </div>
  )
}
